import { useQuery } from "@apollo/client";
import { useMemo } from "react";

import { AutocompleteAddressesDocument } from "./queries.generated";
import { UseAddressAutocompleteItem, UseAddressAutocompleteReturn } from "./types";

export default function useAddressAutocomplete(search: string): UseAddressAutocompleteReturn {
    const { data, loading, error } = useQuery(AutocompleteAddressesDocument, {
        variables: { search },
        skip: search.length < 1,
    });

    const addresses: UseAddressAutocompleteItem[] = useMemo(() => {
        return (
            data?.autocompleteAddresses?.map(item => ({
                label: item.label,
                addressId: item.value,
            })) ?? []
        );
    }, [data]);

    return {
        addresses,
        isLoading: loading,
        error: error as Error | undefined,
    };
}
